(function () {
  'use strict';
  if (window.ADGProductTotals) return;
  var states = new WeakMap();
  var active = new Set();

  function cents(value) {
    var cleaned = String(value == null ? '' : value).replace(/[\s\u00a0\u202f]/g, '').replace(',', '.');
    var amount = Number(cleaned);
    return cleaned && Number.isFinite(amount) ? Math.round(amount * 100) : null;
  }

  function labelledExtra(text) {
    var total = 0;
    String(text || '').replace(/\+\s*([\d\s\u00a0\u202f]+(?:[,.]\d{1,2})?)\s*(?:€|EUR)/gi, function (_, amount) {
      total += cents(amount) || 0;
      return _;
    });
    return total;
  }

  function inputLabel(input, root) {
    var associated = input.labels && Array.from(input.labels).find(function (label) { return root.contains(label); });
    if (associated) return associated.textContent;
    var label = input.closest('label');
    if (label) return label.textContent;
    if (input.id) {
      label = Array.from(root.querySelectorAll('label')).find(function (el) { return el.htmlFor === input.id; });
      if (label) return label.textContent;
    }
    return input.nextElementSibling ? input.nextElementSibling.textContent : input.value;
  }

  function extra(form) {
    var labelled = 0;
    form.querySelectorAll('ymq-option select,.mw-product-options select').forEach(function (select) {
      if (select.disabled) return;
      Array.from(select.options).filter(function (option) { return option.selected; }).forEach(function (option) { labelled += labelledExtra(option.textContent); });
    });
    form.querySelectorAll('ymq-option input:checked,.mw-product-options input:checked').forEach(function (input) {
      if (!input.disabled) labelled += labelledExtra(inputLabel(input, form));
    });
    var field = form.querySelector('input[name="properties[_YmqItemPrice]"]');
    var value = field ? cents(field.value) : null;
    return value !== null && value !== 0 ? value : labelled;
  }

  function update(form) {
    if (!form) return;
    var base = Number(form.getAttribute('data-adg-base-price'));
    var variantInput = form.querySelector('[name="id"]');
    if (variantInput) {
      var option = variantInput.options && variantInput.options[variantInput.selectedIndex];
      if (option && option.hasAttribute('data-variant-price')) base = Number(option.getAttribute('data-variant-price'));
      else {
        var state = states.get(form);
        var variant = state && state.variants.find(function (v) { return String(v.id) === variantInput.value; });
        if (variant) base = Number(variant.price);
      }
    }
    if (!Number.isFinite(base)) return;
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = Math.max(1, parseInt(quantityInput && quantityInput.value, 10) || 1);
    var addon = extra(form);
    var unit = base + addon;
    var format = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: form.getAttribute('data-adg-currency') || 'EUR' });
    var candleExtra = window.ADGBoutiqueCandles ? window.ADGBoutiqueCandles.extra(form) : 0;
    var label = format.format((unit * quantity + candleExtra) / 100);
    function set(el, text) { if (el.textContent !== text) el.textContent = text; }
    form.querySelectorAll('.adg-product-total-amount,.js-total-price').forEach(function (el) { set(el, label); });
    form.querySelectorAll('[id^="AdgProductTotalNote-"]').forEach(function (el) {
      set(el, quantity + ' produit' + (quantity > 1 ? 's' : '') + ' × ' + format.format(unit / 100) + (addon ? ' · options incluses' : '') + (candleExtra ? ' + ' + format.format(candleExtra / 100) + ' ' + (form.querySelector('[data-candles]')?.dataset.totalLabel || '') : ''));
    });
    form.querySelectorAll('[data-adg-custom-total]').forEach(function (el) {
      set(el, quantity + ' ' + el.getAttribute('data-adg-custom-total') + ' · ' + label);
    });
    return { quantity: quantity, unit: unit, total: unit * quantity + candleExtra, addon: addon };
  }

  function mount(form) {
    if (states.has(form)) return;
    var variants = [];
    try { variants = JSON.parse(form.getAttribute('data-adg-variants') || '[]'); } catch (_) {}
    var state = { variants: variants, timers: [] };
    states.set(form, state);
    active.add(form);
    function refresh() {
      state.timers.forEach(clearTimeout);
      state.timers = [0, 100, 350, 1000].map(function (delay) {
        return setTimeout(function () { if (form.isConnected) update(form); }, delay);
      });
    }
    form.addEventListener('change', refresh);
    form.addEventListener('input', refresh);
    form.addEventListener('click', refresh);
    update(form);
  }

  function scan(root) {
    if (root.matches && root.matches('form[data-adg-total-form]')) mount(root);
    if (root.querySelectorAll) root.querySelectorAll('form[data-adg-total-form]').forEach(mount);
  }

  window.ADGProductTotals = { update: update, scan: scan };
  function start() {
    scan(document);
    new MutationObserver(function (records) {
      records.forEach(function (record) { record.addedNodes.forEach(function (node) { if (node.nodeType === 1) scan(node); }); });
    }).observe(document.body, { childList: true, subtree: true });
    setInterval(function () {
      active.forEach(function (form) {
        if (!form.isConnected) { active.delete(form); return; }
        if (!document.hidden && form.getClientRects().length) update(form);
      });
    }, 400);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


